export function checkReorderPointVsOrderUpTo(reorderPoint, orderUpToLevel) {
    if (reorderPoint != null && orderUpToLevel != null && reorderPoint > orderUpToLevel) {
        return 'Reorder point cannot exceed order-up-to level.';
    }
    return null;
}
export function checkPrimaryVendorCount(vendorParts) {
    const primaryCount = vendorParts.filter((vendorPart) => vendorPart.defaultFlag ?? true).length;
    return primaryCount > 1 ? 'Only one vendor association can be marked as primary.' : null;
}
//# sourceMappingURL=rules.js.map